import React from 'react'
import PropTypes from 'prop-types'
import AdminTooltip from 'components/AdminTooltip'
import {
  AdminSortButtonWrapper,
  StyledPathwayProgressIcon,
  StyledSortButton,
} from './component.styles'

const AdminSortButton = ({
  className,
  currentPacingName,
  handleOnClick,
  isActive,
  isCaretUp,
  monitorView,
  programKey,
  snapshotSource,
  sortKey,
  title,
  tooltipLocation,
}) => (
  <AdminSortButtonWrapper
    className={sortKey || className}
    isActive={isActive}
    monitorView={monitorView}
  >
    <StyledSortButton
      handleOnClick={() => handleOnClick()}
      isActive={isActive}
      isCaretUp={isCaretUp}
      title={title}
    >
      <AdminTooltip
        label={title}
        location={tooltipLocation}
        monitorView={monitorView}
        programKey={programKey}
        snapshotSource={snapshotSource}
      />
      {currentPacingName === title && <StyledPathwayProgressIcon />}
    </StyledSortButton>
  </AdminSortButtonWrapper>
)

AdminSortButton.propTypes = {
  className: PropTypes.string,
  currentPacingName: PropTypes.string,
  handleOnClick: PropTypes.func,
  isActive: PropTypes.bool,
  isCaretUp: PropTypes.bool,
  monitorView: PropTypes.bool,
  programKey: PropTypes.string,
  snapshotSource: PropTypes.string,
  sortKey: PropTypes.string,
  title: PropTypes.string,
  tooltipLocation: PropTypes.string,
}

export default AdminSortButton
